import * as React from 'react';
import './tutorialCompletionNotificationPane.module.scss';
import CompleteTutorialImage from './images/complete_tutorial.svg';
import { TwitterShareButton } from '../../atoms/buttons/TwitterShareButton';
import { FacebookShareButton } from '../../atoms/buttons/FacebookShareButton';

export const TutorialCompletionNotificationPane = () => {
    const prefillText = `5ステップ完了おめでとう！！この調子でどんどんSHElikesを活用してね🌟`;
    const ogpUrl = `https://likes.she-inc.jp/v3/all_tutorial_completion`;
    return (
        <div id="tutorial_completion_notification" styleName="pane">
            <img styleName="thumbnail" src={CompleteTutorialImage} />
            <div styleName="text main">
                全部完了したね！<br />すごい！！この調子でどんどんレッスンを受講していってね🌟
            </div>
            <div styleName="border" />
            <div styleName="text sub">あなたの頑張りをSHEメイトのみんなに教えてね！</div>
            <div styleName="button-toolbar">
                <TwitterShareButton dataText={prefillText} dataUrl={ogpUrl}>
                    Twitterでシェア
                </TwitterShareButton>
                <FacebookShareButton dataUrl={ogpUrl}>Facebookでシェア</FacebookShareButton>
            </div>
        </div>
    );
};
